<script setup lang="ts">
import { ref } from 'vue';
import type { BookingFormData } from '../../types/treatment';

const props = defineProps<{
  type: 'massage' | 'yogatherapy';
  isOpen: boolean;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'submit', data: BookingFormData): void;
}>();

const formData = ref<BookingFormData>({
  date: '',
  time: '',
  notes: ''
});

function handleSubmit() {
  emit('submit', { ...formData.value });
  emit('close');
  formData.value = { date: '', time: '', notes: '' };
}
</script>

<template>
  <div v-if="isOpen" class="modal-overlay" @click="emit('close')">
    <div class="modal-content" @click.stop>
      <h3>{{ type === 'massage' ? 'Massage buchen' : 'Yogatherapie buchen' }}</h3>
      
      <form @submit.prevent="handleSubmit" class="booking-form">
        <div class="form-group">
          <label for="date">Datum</label>
          <input
            type="date"
            id="date"
            v-model="formData.date"
            required
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="time">Uhrzeit</label>
          <input
            type="time"
            id="time"
            v-model="formData.time"
            required
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="notes">Anmerkungen</label>
          <textarea
            id="notes"
            v-model="formData.notes"
            rows="3"
            class="form-input"
          ></textarea>
        </div>

        <div class="button-group">
          <button type="button" class="cancel" @click="emit('close')">
            Abbrechen
          </button>
          <button type="submit" class="submit">
            Buchen
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}

h3 {
  color: #960040;
  margin-bottom: 1.5rem;
}

.booking-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

label {
  color: #333;
  font-weight: 500;
}

.button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

button {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  flex: 1;
}

.cancel {
  background: #f3f4f6;
  color: #374151;
}

.submit {
  background: #960040;
  color: white;
}

.submit:hover {
  background: #7d0035;
}
</style>